/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { InterventionTaskViewModel } from './InterventionTaskViewModel'; 

export function getInterventionTaskOptions(interventionTaskId: string, onSuccess?: (result: InterventionTaskViewModel) => void) {
	return queryOptions({
		queryKey: ['intervention-task', interventionTaskId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/workflows/queries/getinterventiontask/' + interventionTaskId;
			const resp = await axios.get<InterventionTaskViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(interventionTaskId)
	});
}